// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import BecomeADealer from './PageComponent/become-a-dealer';

function Trade() {

  useMeta({
    title: 'Become a Dealer in your region for Callistus Blinds - Connect now',
    description: 'Being the most Innovative, Quality Oriented and determined to give unparalleled Service is our Motto. Grab the opportunity for Dealership now',
    canonical: 'https://callistusblinds.com/become-a-dealer/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Become a Dealer in your region for Callistus Blinds - Connect now',
      description:
        'Being the most Innovative, Quality Oriented and determined to give unparalleled Service is our Motto. Grab the opportunity for Dealership now',
      url: 'https://callistusblinds.com/become-a-dealer/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <BecomeADealer />
      <Footer />
    </div>
  );
}

export default Trade;
